import { validateAndFormat } from "../../common/addNew/validateAndFormat";

/**
 * Actions for events
 */
export const actions = {
  /**
   * Validate form field
   *
   * @param {Object} context
   */
  validate(context) {
    // Step 1: Validate and format everything
    const name = validateAndFormat.name(
      context.rootGetters["addNew/getName"].firstName,
      context
    );

    // Step 2: Send if valid or not
    context.commit("setValidated", name !== false);
  },

  /**
   * Send add client request
   *
   * @param {Object} context
   */
  async addEvent(context, onlyThis) {
    // Start loading
    context.commit("addNew/startLoading", null, { root: true });
    context.commit("addNew/setFormSubmitted", false, { root: true }); // Form not submitted

    // Step 0 Getting the selected provider id
    const selectedProviderId = context.rootGetters.getSelectedProviderID;

    // Step 1: Validate and format everything
    const name = validateAndFormat.name(
      context.rootGetters["addNew/getName"].firstName,
      context
    );

    // Step 2: Check if everything is valid
    if (name) {
      // Step 3: Creating request data
      const requestData = {
        name,
        providerID: selectedProviderId
      };

      // Step 4: Sending auth request, if event is being saved for future use
      let event = false;
      if (!onlyThis) {
        /**
         *  Response format
         * {
         *   code: 200,
         *   event: {
         *      id: 100, // The id of the new added appointment
         *      name: "abc", // The name of the new added appointment
         *      providerID: 3159 // The provider id of the new added appointment
         *   }
         * }
         */
        const json = await context.dispatch(
          "makeAuthRequest",
          {
            url: "events/add",
            method: "POST",

            data: requestData
          },
          { root: true }
        );

        // Insert into form details if required
        if ("event" in json) {
          event = json.event;
        }
      } else {
        event = {
          id: 0,
          name
        };
      }

      if (event) {
        // Add to form list
        context.commit(
          "addToEventListInForm",
          {
            event: { ...event, name },
            providerId: selectedProviderId,
            onlyThis
          },
          { root: true }
        );
      }
      context.commit("addNew/setFormSubmitted", true, { root: true }); // Form not submitted
    }

    // Stop loading
    context.commit("addNew/stopLoading", null, { root: true });
  }
};
